import React, { useState } from "react";
import { FormControl, FormLabel, Input } from "@chakra-ui/react";
import { useIntl } from "react-intl";

const LimitedInput = ({
  name,
  label,
  placeholder,
  isRequired = false,
  value,
  onChange,
}) => {
  const [error, setError] = useState("");

  const { sav_form } = useIntl().messages;

  const isAscii = (char) => {
    return char.charCodeAt(0) >= 0x00 && char.charCodeAt(0) <= 0xff;
  };

  const ansiLength = (str) => {
    let length = 0;
    for (let char of str) {
      if (isAscii(char)) {
        length++;
      } else {
        length += 2;
      }
    }
    return length;
  };

  const handleInputChange = (e) => {
    let length = 0;
    let truncatedValue = "";
    for (let char of e.target.value) {
      length += ansiLength(char);
      if (length <= 35) {
        truncatedValue += char;
        setError("");
      } else {
        setError(sav_form.size_limit);
        break;
      }
    }
    onChange(truncatedValue);
  };

  return (
    <FormControl isRequired={isRequired}>
      <FormLabel>{label}</FormLabel>
      <Input
        type="text"
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={handleInputChange}
      />
      {!!error && (
        <span
          style={{
            color: "#FE5C4C",
            fontSize: "0.65rem",
          }}
        >
          {error}
        </span>
      )}
    </FormControl>
  );
};

export default LimitedInput;
